import { defaultDateLib } from "../classes/index.js";
/**
 * Determines whether a given date is inside a specified date range.
 *
 * @since 9.0.0
 * @group Utilities
 */
export function rangeIncludesDate(range, date) {
  var excludeEnds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dateLib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultDateLib;
  var from = range.from,
    to = range.to;
  var differenceInCalendarDays = dateLib.differenceInCalendarDays,
    isSameDay = dateLib.isSameDay;
  if (from && to) {
    var isRangeInverted = differenceInCalendarDays(to, from) < 0;
    if (isRangeInverted) {
      var _ref = [to, from];
      from = _ref[0];
      to = _ref[1];
    }
    var isInRange = differenceInCalendarDays(date, from) >= (excludeEnds ? 1 : 0) && differenceInCalendarDays(to, date) >= (excludeEnds ? 1 : 0);
    return isInRange;
  }
  if (!excludeEnds && to) {
    return isSameDay(to, date);
  }
  if (!excludeEnds && from) {
    return isSameDay(from, date);
  }
  return false;
}
/**
 * @private
 * @deprecated Use {@link rangeIncludesDate} instead.
 */
export var isDateInRange = function isDateInRange(range, date) {
  return rangeIncludesDate(range, date, false, defaultDateLib);
};